var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.8 14.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #212322;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.4,14.8C3.32,14.8,0,11.48,0,7.4S3.32,0,7.4,0s7.4,3.32,7.4,7.4-3.32,7.4-7.4,7.4Zm0-13.8C3.87,1,1,3.87,1,7.4s2.87,6.4,6.4,6.4,6.4-2.87,6.4-6.4S10.93,1,7.4,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.4,11.97c-2.52,0-4.57-2.05-4.57-4.57S4.88,2.83,7.4,2.83s4.57,2.05,4.57,4.57-2.05,4.57-4.57,4.57Zm0-8.14c-1.97,0-3.57,1.6-3.57,3.57s1.6,3.57,3.57,3.57,3.57-1.6,3.57-3.57-1.6-3.57-3.57-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.4,9.25c-1.02,0-1.85-.83-1.85-1.85s.83-1.85,1.85-1.85,1.85.83,1.85,1.85-.83,1.85-1.85,1.85Zm0-2.7c-.47,0-.85.38-.85.85s.38.85.85.85.85-.38.85-.85-.38-.85-.85-.85Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.ddb091e8e4d221ff6661ac2c6cee698a.svg";
export { ForwardRef as ReactComponent };